import { createFileRoute } from "@tanstack/react-router";
import { IncomeCategoryTableColumns } from "@/components/income-category/income-category-meta";
import { IncomeCategoryModals } from "@/components/income-category/income-category-modals";
import FullPagination from "@/components/ui/shared/full-pagination";
import { SearchEngine } from "@/components/ui/shared/search-engine";
import { Button } from "@/components/ui/button";
import SimpleTable from "@/components/ui/table";
import { useSimpleForm } from "@/hooks/use-simple-form";
import useAppStore from "@/store";
import { Banknote, Plus } from "lucide-react";
import { useEffect } from "react";
import { useTranslate } from "@/hooks/use-translate";

export const Route = createFileRoute("/(dasboard)/finance/income-categories")({
  component: IncomeCategoriesPages,
});

function IncomeCategoriesPages() {
  const store = useAppStore();
  const { t } = useTranslate();

  const searchForm = useSimpleForm({
    keyword: "",
  });

  const search = ({ page = 1, per_page = 10 } = {}) => {
    store.financeCategory.fetch({
      page,
      per_page,
      ...searchForm.values,
      type: "income",
    });
  };

  useEffect(() => {
    if (store.auth.session) {
      search();
    }
  }, [store.auth.session]);

  return (
    <>
      <IncomeCategoryModals />

      <div className="max-w-7xl mx-auto">
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold"> {t("Income categories")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_income_category");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add category")}
          </Button>
        </header>

        <SearchEngine
          autoComplete={(values: any) => {
            store.financeCategory.paginate(
              store.financeCategory.items.filter(
                (fc: any) =>
                  fc.title
                    .toLowerCase()
                    .includes(values.keyword?.toLowerCase()) &&
                  (values.type ? values.type == fc.type : true) &&
                  (values.ohada_code_id
                    ? values.ohada_code_id == fc.ohada_code_id
                    : true)
              )
            );
          }}
          form={searchForm}
          onSubmit={undefined}
          selects={[
            {
              placeholder: t("All OHADA codes"),
              options: store.ohadaCode.items.map((item) => ({
                value: item.id,
                label: `${item.id} ${item.title}`,
              })),
              name: "ohada_code_id",
              icon: <Banknote className="w-4 h-4" />,
              size: "w-[400px]",
            },
          ]}
        />

        <SimpleTable
          items={store.financeCategory.pagination.data}
          columns={IncomeCategoryTableColumns({
            onView: (category: any) => {
              store.financeCategory.setCurrent(category);
              store.display.show("view_income_category");
            },
            onEdit: (category: any) => {
              store.financeCategory.setCurrent(category);
              store.display.show("edit_income_category");
            },
            onDelete: async (category: any) => {
              store.financeCategory.setCurrent(category);
              store.display.show("delete_finance_category");
            },
          })}
        />

        <FullPagination
          className="mt-4"
          canEdit={true}
          pagination={store.financeCategory.pagination}
          onGoto={(page) => search({ page })}
          onPerPage={(per_page) => search({ per_page })}
        />
      </div>
    </>
  );
}
